module.exports = __webpack_public_path__ + "img/formador-5.fc85c46b.png";